export const COLUMNS_PEDIDO_CAMIONES_EN_PLAYA_INSATISFECHO = [
  {
    name: 'fechaDePedido',
    label: 'Fecha de pedido',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cantidad',
    label: 'Cantidad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'restantes',
    label: 'Restan',
    options: {
      filter: true,
      sort: true
    }
  }

]
export const COLUMNS_PEDIDO_CAMIONES_EN_PLAYA_TO_PRINT_INSATISFECHO = [
  {
    name: 'fechaDePedido',
    label: 'Fecha de pedido',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cantidad',
    label: 'Cantidad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'restantes',
    label: 'Restan',
    width: 60,
    mantenerCase: true
  }
]
